// extracted by mini-css-extract-plugin
module.exports = {"dotsGroup":"style_dotsGroup__3VjdT","dot":"style_dot__RibRh","active":"style_active__3KtZH"};